import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: /* @__PURE__ */ _jsx("polyline", {
		points: "112 184 256 328 400 184",
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 32
		}
	})
});
export default SvgIChevronDown;
